export const tenantFilterOptions = [
  { label: "Company Name", value: false },
  { label: "Email", value: false },
  { label: "Timezone", value: false },
  { label: "Payment Pending", value: false },
  { label: "Status", value: false },
  { label: "Onboarded date", value: false },
  { label: "Subscription Plan", value: false },
  { label: "Address", value: false }
];

export const STATUS_OPTIONS = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];
export interface TimezoneOption {
  id: number;
  value: string;
}
export interface TimezoneFilterProps {
  value?: string[];
  onChange: (value: string[]) => void;
  timezones: TimezoneOption[];
  isTimezoneEnabled?: boolean;
  multiple?: boolean;
  error?: string;
}
export interface SubscriptionPlanFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  plans: string[];
  label?: string;
  error?: string;
  isMultiple?: boolean;
}
export interface StatusFilterProps {
  value: string[];
  onChange: (selected: string[]) => void;
  error?: string;
  isStatusEnabled: boolean;
}
export interface OnboardedDateFilterProps {
  startDate?: Date | null;
  endDate?: Date | null;
  onDateRangeChange: (start: string | null, end: string | null) => void;
  startDateError?: string;
  endDateError?: string;
}
export interface EmailFilterProps {
  value: string;
  error?: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  isEmailEnabled: boolean;
}
export interface CompanyNameFilterProps {
  value: string[];
  error?: string;
  onChange: (value: string[]) => void;
  isCompanyNameEnabled: boolean;
  companyNames: string[];
  isMultiple?: boolean;
  label?: string;
}

export interface AddressFilterProps {
  value: { country: string; state: string; city: string; zipcode: string };
  error?: string;
  setFieldValue: ((field: string, value: string) => void) | undefined;
}